export class ProductActivityHour {
  productActivityId!: string;
  fromTime!: string;
  toTime!: string;
  stopTime!: string;
  isForAllProducts!: boolean;
  service!:string;
  serviceTime!: string;
}
